export enum GuestMessageType {
  PREVIEW = "preview",
  VOUCHER_GUEST_MAIL = "voucher_guest_mail",
  VOUCHER_GUEST_POST = "voucher_guest_post",
  REQUEST_GUEST = "request_guest",
  NEWSLETTER_SYNC_DOUBLE_OPT_IN = "newsletter_sync_double_opt_in",
  PAYMENT_CONFIRMATION_ON_SITE = "payment_confirmation_on_site",
  PAYMENT_CONFIRMATION_BANK_TRANSFER = "payment_confirmation_bank_transfer",
  BOOKED_GUEST = "booked_guest",
}
